import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Accordion } from '@ff-os/shared-react/components/accordion/Accordion';
import { AccordionField } from '@ff-os/shared-react/components/accordion/partials/AccordionField';
import { AccordionMenu } from '@ff-os/shared-react/components/accordion/partials/AccordionMenu';
import { VariantOption } from '../../VariantOption';
import { VariantRadioGroup } from './VariantRadioGroup';

export const VariantRadioGroupAccordion = ({
    title, maxHeight = '45vh',
    value, options, onChange
}: Props) => {

    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(true);

    return (
        <Accordion>
            <AccordionField onClick={() => setOpen(!isOpen)} active={isOpen}>
                {t(title)}
            </AccordionField>
            <AccordionMenu active={isOpen} maxHeight={maxHeight}>
                <VariantRadioGroup options={options} onChange={onChange} selected={value} />
            </AccordionMenu>
        </Accordion>
    );
};

type Props = {
    title: string;
    value: string | undefined;
    options: VariantOption[];
    maxHeight?: number | string;
    onChange: (value: string) => void;
};